// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
        overflow: scroll; /* or overflow: auto; */
}
.colors .item:nth-child(8n+1) {
        margin-left: 10px !important;
}
.filepond--wrapper{
        width:unset !important;
}
.filepond--credits{
        display:none;
}
.nova-blur {
        filter: blur(4px);
}
.nova-block-list-item {
        transition: all 0.3s ease;
}
.nova-block-list-enter-from,
    .nova-block-list-leave-to {
        opacity: 0;
      /*  transform: translateX(30px);     */
}
.nova-block-list-leave-active 
    {
       /* position: absolute;*/
}
.nova-block-list-move {
        transition: transform 0.8s ease;
}
.tox .tox-dialog--width-lg{
        max-height: 500px !important;
        max-width: calc(100hw * 0.7) !important
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
